"use client";
import { Html } from "@/Components";
import { ContentSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const Content: FC<ContentSectionProps> = ({ setting }) => {
  return (
    <div className="container">
      <div className="card my-3">
        <div className="card-body pt-0">
          {/* Tab Menu */}
          <h3 className="pt-4">{setting.Title}</h3>
          <hr />
          {/* /Tab Menu */}
          {/* Tab Content */}
          <div className="tab-content pt-3">
            {/* Overview Content */}
            <div
              role="tabpanel"
              id="doc_overview"
              className="tab-pane fade show active"
            >
              <Html value={setting.Content} />
            </div>
            {/* /Overview Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
